export default (theme) => ({
  container: {
    width: 300,
    height: "calc(var(--vh, 1vh) * 100)",
    overflow: "scroll",
    position: "relative",
    display: "block",
  },
});
